"use strict";

module.exports = function clone(source) {
  return Object.keys(source).reduce(function (cloned, key) {
    cloned[key] = source[key];
    return cloned;
  }, {});
};
//# sourceMappingURL=clone.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-schema/lib/utils/clone.js
 ** module id = 964
 ** module chunks = 0
 **/